import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/formGroups'
import Component from 'components/FormGroups'

export default createListViewContainer({ actions, selectors: selectors.formGroups })(Component)
